<template>
  <v-card
    class="text-center mb-0"
    width="300"
  >
    <v-card-text>
      <strong class="mb-3 d-inline-block">FILTROS DA BARRA LATERAL</strong>

      <v-item-group v-model="color">
        <v-item
          v-for="color in colors"
          :key="color"
          :value="color"
        >
          <template v-slot="{ active, toggle }">
            <v-avatar
              :class="active && 'v-settings__item--active'"
              :color="color"
              class="v-settings__item"
              size="25"
              @click="toggle"
            />
          </template>
        </v-item>
      </v-item-group>

      <v-divider class="my-4 secondary" />

      <strong class="mb-3 d-inline-block">FUNDO DA BARRA LATERAL</strong>

      <v-item-group v-model="scrim">
        <v-item
          v-for="scrim in scrims"
          :key="scrim"
          :value="scrim"
          class="mx-1"
        >
          <template v-slot="{ active, toggle }">
            <v-avatar
              :class="active && 'v-settings__item--active'"
              :color="scrim"
              class="v-settings__item"
              size="24"
              @click="toggle"
            />
          </template>
        </v-item>
      </v-item-group>

      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          Modo Escuro
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="$vuetify.theme.dark"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
            @change="onChangeThemeDark($event)"
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          Barra Lateral Mini
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="internalValue"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          Imagem na Barra Lateral
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="showImagem"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />
      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          Notificações Push
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="enviaNotif"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-4 secondary" />
      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          Notificações Pop-up
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="poppup"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />
      <strong class="mb-3 d-inline-block">IMAGENS</strong>

      <v-item-group
        v-model="image"
        class="d-flex justify-space-between mb-3"
      >
        <v-item
          v-for="image in images"
          :key="image"
          :value="image"
          class="mx-1"
        >
          <template v-slot="{ active, toggle }">
            <v-sheet
              :class="active && 'v-settings__item--active'"
              class="d-inline-block v-settings__item"
              @click="toggle"
            >
              <v-img
                :src="image"
                height="100"
                width="50"
              />
            </v-sheet>
          </template>
        </v-item>
      </v-item-group>
      <div class="my-12" />
    </v-card-text>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState } from 'vuex'
  import usuarioprodutor from '../../../../services/usuarioprodutor'

  export default {
    name: 'DashboardCoreSettings',

    mixins: [Proxyable],

    data: () => ({
      color: '#45a048', //  #4CAF50
      colors: [
        '#9C27b0',
        '#2863af',
        '#45a048',
        '#ff9800',
        '#E91E63',
        '#FF5252',
      ],
      image: '/img/sidebar-1.jpg',
      images: [
        '/img/sidebar-2.jpg',
        '/img/sidebar-3.jpg',
        '/img/sidebar-4.jpg',
        '/img/sidebar-5.jpg',
      ],
      menu: false,
      saveImage: '',
      scrim: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
      scrims: [
        'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
        'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
        'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
      ],
      showImagem: true,
      enviaNotif: true,
      poppup: true,
    }),

    computed: {
      ...mapState(['barImage']),
    },

    watch: {
      color (val) {
        this.$vuetify.theme.themes[this.isDark ? 'dark' : 'light'].primary = val
        localStorage.setItem('primary', val)
      },
      showImagem (val) {
        localStorage.setItem('showImagem', val)
        if (!val) {
          this.saveImage = this.barImage
          this.setBarImage('')
        } else if (this.saveImage) {
          this.setBarImage(this.saveImage)
          this.saveImage = ''
        } else {
          this.setBarImage(val)
        }
      },
      image (val) {
        this.setBarImage(val)
        localStorage.setItem('barImage', val)
      },
      scrim (val) {
        this.$store.commit('SET_SCRIM', val)
        localStorage.setItem('scrim', val)
      },
      internalValue (val) {
        localStorage.setItem('internalValue', val)
      },
      enviaNotif (val) {
        // this.enviaMsgPush()
        localStorage.setItem('enviaNotif', val)
      },
      poppup (val) {
        // this.enviaMsgPush()
        localStorage.setItem('poppup', val)
      },
    },

    mounted () {
      this.carregaSettings()
    },

    methods: {
      ...mapMutations({
        setBarImage: 'SET_BAR_IMAGE',
      }),
      onChangeThemeDark (event) {
        localStorage.setItem('isDark', event)
        this.carregaSettings()
      },
      carregaSettings () {
        if (!localStorage.getItem('primary') || localStorage.getItem('primary') === 'null') {
          localStorage.setItem('primary', '#45a048')
        }
        if (localStorage.getItem('isDark')) {
          this.isDark = localStorage.getItem('isDark') === 'true'
          this.$vuetify.theme.dark = this.isDark
        }

        if (localStorage.getItem('primary')) {
          this.$vuetify.theme.themes[this.isDark ? 'dark' : 'light'].primary = localStorage.getItem('primary')
          this.color = localStorage.getItem('primary')
        }

        if (localStorage.getItem('barImage')) {
          this.setBarImage(localStorage.getItem('barImage'))
        }
        if (localStorage.getItem('showImagem')) {
          this.showImagem = localStorage.getItem('showImagem') === 'true'
          //  console.log(this.showImagem)
        }

        if (localStorage.getItem('scrim')) {
          this.$store.commit('SET_SCRIM', localStorage.getItem('scrim'))
        }

        if (localStorage.getItem('internalValue')) {
          this.internalValue = localStorage.getItem('internalValue') === 'true'
        }
        if (localStorage.getItem('enviaNotif')) {
          this.enviaNotif = localStorage.getItem('enviaNotif') === 'true'
          // console.log(this.enviaNotif)
        }

        if (localStorage.getItem('poppup')) {
          this.poppup = localStorage.getItem('poppup') === 'true'
          // console.log(this.poppup)
        }
      },
      enviaMsgPush () {
        usuarioprodutor.enviaMensagem(localStorage.chaveativacao, localStorage.enviaNotif).then(resposta => {
          // this.enviaNotif = localStorage.getItem('enviaNotif')
        }).catch(e => {
          e.message = 'Erro ao configurar as notificações push'
        })
      },
    },
  }
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
  #settings
    top: 58px !important
</style>
